var map = {
	"./1.png": 34830,
	"./10.png": 29595,
	"./11.png": 85771,
	"./12.png": 1135,
	"./13.png": 9512,
	"./14.png": 80860,
	"./15.png": 59806,
	"./2.png": 91645,
	"./3.png": 28241,
	"./4.png": 73344,
	"./5.png": 20734,
	"./6.png": 15446,
	"./7.png": 68196,
	"./8.png": 90612,
	"./9.png": 91688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64208;